import styled from 'styled-components'

export const Container = styled.div`
  position: absolute;
  top: 54px;
  display: flex;
  width: 100%;
  height: auto;
  background: transparent;
  border-radius: 5px;
  z-index: 1000;
`

export const SuggestionList = styled.ul`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  height: auto;
  list-style: none;
  margin: 0;
  padding: 0;
`
